export default "__VITE_ASSET__BF51qESr__"